/** @import { adminMachineResponse } from "~/backend/validate.js"; */

import Query from "~/util/query.js";

import { renameMachineModal } from "~/component/RenameMachineModal.js";

/**
 * @param {{ orgId: string }} props
 * @param {adminMachineResponse} machine
 */
export const renameComputer = async ({ orgId }, machine) => {
	const renamed = await renameMachineModal(machine);
	if (!renamed) return;

	Query.invalidate(
		[`/ui/admin/orgs/${orgId}/machines`],
		[`/ui/admin/orgs/${orgId}/machines/${machine.id}`],
		[`/ui/admin/orgs/${orgId}/members`],
	);
	return renamed;
};
